import React, { Component } from 'react';
import { QUESTION_TYPE } from './SurveyContainer.js';
import { translate } from 'react-i18next';

class QuestionsForm extends Component {

  renderQuestion = (question, index) => {
    return(
      <tr key={index}>
        <td>
          <div className={question.link ? "" : "hidden"}>
            <a href={question.link} rel="noopener noreferrer" target="_blank">
              {question.name}
            </a>
          </div>
          <div className={question.link ? "hidden" : ""}>
            <p>{question.name}</p>
          </div>
        </td>
        <td className="text-center">
          <div className={question.type === QUESTION_TYPE.OPTIONS ? "" : "hidden"}>
            <div className="form-group">
              <span className="option">
                <input name={question.id} type="radio" value="1" />
              </span>
              <span className="option">
                <input name={question.id} type="radio" value="2" />
              </span>
              <span className="option">
                <input name={question.id} type="radio" value="3" />
              </span>
              <span className="option">
                <input name={question.id} type="radio" value="4" />
              </span>
              <span className="option">
                <input name={question.id} type="radio" value="5" />
              </span>
              <span className="option">
                <input name={question.id} type="radio" value="0" />
              </span>
            </div>
          </div>
        </td>
        <td>
          <div className="form-group">
            <textarea className="form-control" id={question.id} />
          </div>
        </td>
      </tr>
    );
  }

  renderSection = (section, index) => {
    const { t } = this.props;
    return(
      <div className="table-responsive" key={index}>       
        <table className="questions-table table table-bordered table-striped">
          <thead>
            <tr>
              <th>{section.name}</th>
              <th className="text-center">
                <span className="option">1</span>
                <span className="option">2</span>
                <span className="option">3</span>
                <span className="option">4</span>
                <span className="option">5</span>
                <span className="option">{t('guest.survey.col_na')}</span>
              </th>
              <th>{t('guest.survey.col_comments')}</th>
            </tr>
          </thead>
          <tbody>
            {section.questions.map((question, index) => this.renderQuestion(question, index))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    return(
      <div>
        <div className="alert alert-warning">
          {t('guest.survey.instructions')}
        </div>
        <form method="post" onSubmit={this.props.handleQuestionsForm}>
          <fieldset>
            {this.props.survey.sections.map((section, index) => this.renderSection(section, index))}
            <div className="form-group text-center">
              <button
                className="btn btn-primary"
                type="submit">
                {t('guest.survey.btn_continue')}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default translate('common')(QuestionsForm);



// WEBPACK FOOTER //
// ./src/guest/survey/QuestionsForm.js